export default __webpack_public_path__ + "assets/93dc8a60836733eb43be2978b979fcce.svg";